import { render, staticRenderFns } from "./ObiPortalEditor.vue?vue&type=template&id=aa75d5b0&"
import script from "./ObiPortalEditor.vue?vue&type=script&lang=js&"
export * from "./ObiPortalEditor.vue?vue&type=script&lang=js&"
import style0 from "./ObiPortalEditor.vue?vue&type=style&index=0&id=aa75d5b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports